import type { ResultOf } from '@graphql-typed-document-node/core';

import Box from '@mui/material/Box';

import { getFragmentData, graphql } from '@e-socna/data-layer';
import type { FragmentType } from '@e-socna/data-layer';

import { NoData } from '../../../../components/Illustrations/NoData';
import { useReferencesContext } from '../../../../contexts/ReferencesContext/hooks/useReferencesContext.hook';
import { DataGrid } from '../../../../components/DataGrid';

import { getColumns } from './get-columns';
import { getRowId } from './utils/get-row-id.util';
import { useInitialGridState } from './hooks/useInitialGridState.hook';

export const ResolvableServicePage_MaterialUsagesList_MaterialUsage_Fragment =
  graphql(`
    fragment ResolvableServicePage_MaterialUsagesList_MaterialUsage_Fragment on MaterialUsage {
      _id
      material {
        _id
        code
        label
        statusId
      }
      quantity {
        value
        unitId
      }
    }
  `);

export type ResolvableServicePage_MaterialUsagesList_MaterialUsage = ResultOf<
  typeof ResolvableServicePage_MaterialUsagesList_MaterialUsage_Fragment
>;

interface Props {
  readonly materialUsages: readonly FragmentType<
    typeof ResolvableServicePage_MaterialUsagesList_MaterialUsage_Fragment
  >[];
}

export const List = ({ materialUsages: pMaterialUsages }: Readonly<Props>) => {
  const materialUsages = getFragmentData(
    ResolvableServicePage_MaterialUsagesList_MaterialUsage_Fragment,
    pMaterialUsages,
  );

  const { genericStatuses } = useReferencesContext();

  const { initialGridState } = useInitialGridState();

  return !materialUsages.length ? (
    <NoData />
  ) : (
    <Box sx={{ flexGrow: 1, width: '100%', pt: 2 }}>
      <DataGrid
        columns={getColumns(genericStatuses)}
        getRowId={getRowId}
        initialState={initialGridState}
        rows={materialUsages}
      />
    </Box>
  );
};
